import Newsletter from 'igs-theme-core/src/assets/scripts/modules/newsletter'
import Collapsable from 'igs-theme-core/src/assets/scripts/modules/collapsable'
import LoadPartials from 'igs-theme-core/src/assets/scripts/modules/load-partials'
import Scroll from 'igs-theme-core/src/assets/scripts/modules/scroll'
import Forms from 'igs-theme-core/src/assets/scripts/modules/forms'
import GoogleMap from 'igs-theme-core/src/assets/scripts/modules/google-map'
import ImagePlaceholder from 'igs-theme-core/src/assets/scripts/modules/image-placeholder'
import Header from 'igs-theme-core/src/assets/scripts/modules/header'
import Events from 'igs-theme-core/src/assets/scripts/modules/events'
import Tabs from 'igs-theme-core/src/assets/scripts/modules/tabs'
import FormValidator from 'igs-theme-core/src/assets/scripts/modules/form-validator'
import ModulesFactory from 'igs-theme-core/src/assets/scripts/modules/modules-factory'


import 'igs-theme-core/src/assets/scripts/modules/modal'
import 'fg-loadcss/src/cssrelpreload.js'
import './modules/r-slider'
import LinkManager from './modules/link-manager'
import EventsClickHandler from './modules/events/events-click-handler'
import EventsFormHandler from './modules/events/events-form-handler'

import WebFont from 'webfontloader'

WebFont.load({
    google: {
        families: ['Lato:300,400,700,900', 'Merriweather:ital,wght@0,300;0,400;0,700;0,900;1,300;1,400;1,700;1,900&display=swap'],
    },
    custom: {
        families: ['Font Awesome 5 Brands', 'Font Awesome 5 Free:900,400'],
    },
    events: false,
})

const modules = {
    tabs: Tabs,
    'form-validator': FormValidator,
}

document.addEventListener('DOMContentLoaded', () => {
    new EventsClickHandler()
    new EventsFormHandler()
    new LinkManager()
    
    const gemstoneModels = document.querySelectorAll('.js-gemstone-model a');
    gemstoneModels.forEach((model) => {
        model.addEventListener('click', (e) => {
            e.preventDefault()
            window.open(e.target.href, 'newwindow', 'width=480,height=720');
        });
    })

    const membershipFixedLink = document.querySelector('.js-membership-cta')
    if (membershipFixedLink) {
        membershipFixedLink.addEventListener('click', function (e) {
            membershipFixedLink.parentElement.classList.add('clicked')
        })
        const close = membershipFixedLink.querySelector('[data-close]')
        if (close) {
            close.addEventListener('click', e => {
                e.preventDefault()
                membershipFixedLink.parentElement.classList.add('clicked')
            })
        }
    }


    document.addEventListener('tab_changed', () => {
        window.dispatchEvent(new Event('resize'))
    })
    
    const newsletterForms = document.querySelectorAll('.js-newsletter-form')
    newsletterForms.forEach((newsletterForm) => {
        new Newsletter(newsletterForm)
    })

    const event = document.querySelectorAll('[data-event]')
    event.forEach((el) => {
        el.addEventListener('click', (e) => {
            const data = e.target.dataset.eventValue || null
            Events.sendEvent(e.target.dataset.event, data ? { value: data } : {})
        })

        if (el.tagName === 'SELECT') {
            el.addEventListener('change', (e) => {
                const data = e.target.options[e.target.selectedIndex].text || null
                Events.sendEvent('Change ' + e.target.name, data ? { value: data } : {})
            })
        }
    })


    const collapse = document.querySelectorAll('[data-collapse]')
    collapse.forEach((el) => {
        new Collapsable(el)
    })

    new ModulesFactory(modules)


    const top_feeds = document.querySelectorAll('.js-top-feed-list')
    top_feeds.forEach((top_feed) => {
        new LoadPartials(top_feed, top_feed, 'top_feed_list', 'instant')
    })

    const feeds = document.querySelectorAll('.js-feed-list')
    feeds.forEach((feed) => {
        new LoadPartials(feed, feed, 'feed_list', 'instant')
    })

    const articles = document.querySelectorAll('.js-recent-articles')
    articles.forEach((article) => {
        new LoadPartials(article, article, 'recent_articles', 'instant')
    })
    
    const related_content = document.querySelectorAll('.js-related-content')
    related_content.forEach((related) => {
        new LoadPartials(related, related, 'related_content', 'instant')
    })

    const gemstone_values = document.querySelectorAll('.js-gemstone-values')
    gemstone_values.forEach((related) => {
        new LoadPartials(related, related, 'price_guides_list', 'instant')
    })

    const load_data = document.querySelectorAll('.js-load-data')
    load_data.forEach((data) => {
        new LoadPartials(data, false, false, 'click')
    })


    document.addEventListener('partials_loaded', () => {
        const collapse = document.querySelectorAll('[data-collapse]')
        collapse.forEach((el) => {
            new Collapsable(el)
        })
    })

    const forms = document.querySelectorAll('.js-form')
    forms.forEach((form) => {
        new Forms(form)
    })

  
    new Scroll()
    new GoogleMap()
    new ImagePlaceholder()
    


    const header = document.querySelector('.js-header')
    if (header) {
        new Header(header)
    }
})
